import { render, staticRenderFns } from "./SelfSignUpCampana.vue?vue&type=template&id=2a052507&scoped=true&lang=pug"
import script from "./SelfSignUpCampana.vue?vue&type=script&lang=js"
export * from "./SelfSignUpCampana.vue?vue&type=script&lang=js"
import style0 from "./SelfSignUpCampana.vue?vue&type=style&index=0&id=2a052507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a052507",
  null
  
)

export default component.exports